export default "__VITE_ASSET__BJQldJMq__"